export default __webpack_public_path__ + "36894319e5386167927540566be72c8c.png";